import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _isNil from "lodash-es/isNil";
import _cond from "lodash-es/cond";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import fetch from 'node-fetch';
import moment from 'moment-timezone';
import { formatLocDateMMDDYYYY } from './formatters';
import { getHeaders } from './utils';

const otherwise = () => true;

const outputBlank = () => '';

const formatPostDateIfDefined = _cond([[_isNil, outputBlank], [otherwise, formatLocDateMMDDYYYY]]);
/**
 * Physicians by widget
 * all non ADM orders are
 *    '-9', // PhysicianRoleId
      '-10', // MedicalDirectorRoleId
      '-11', // NursePractitionerRoleId
      '-51', // DoctorOfOsteopathyRoleId
      '-66', // HospicePhysicianRoleId

  ADM and cert are the same
 */


export const getPhysicians = async (keycloak, agency, patient, type, date) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader'); // added so stand alone cert app can access authproxy host name from window.env.

  const windowEnv = window.env;
  const {
    hosts
  } = windowEnv;
  const pimReaderHost = hosts && hosts.pimReader;
  let authProxyUrl = pimReaderHost || `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/get_doctors_with_pecos_status_fn?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patient === null || patient === void 0 ? void 0 : patient.patientNumber}`;
  authProxyUrl += `&p_usecase=${type}`;
  authProxyUrl += `${date ? `&p_search_date=${date}` : ''}`;
  const response = await fetch(authProxyUrl, {
    headers,
    credentials: 'same-origin'
  }); // A 504 is a Gateway Timeout Error

  if (response.status === 200) {
    const doctors = await response.json();
    return doctors;
  }

  return null;
};
export const getPNOrders = async (keycloak, agency, patientNumber, fromdate, todate) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak === null || keycloak === void 0 ? void 0 : keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getorders?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patientNumber}`;
  authProxyUrl += `&p_fromdate=${fromdate || ''}`;
  authProxyUrl += `&p_todate=${todate || ''}`;
  const response = await fetch(authProxyUrl, {
    headers,
    credentials: 'same-origin'
  }); // A 504 is a Gateway Timeout Error

  if (response.status === 200) {
    const pnOrders = await response.json();
    return pnOrders;
  }

  return null;
};
const defaultGetVisitsV2Params = {
  p_patientnumber: '',
  p_patient_id: '',
  p_personnumber: '',
  p_person_id: '',
  p_attributename: '',
  p_fromdate: '',
  p_todate: '',
  p_visitstatus: '',
  p_latest: false,
  p_patientvisit_id: '',
  p_siteoffice: '',
  p_mindurationmins: '',
  p_minchartingmins: '',
  p_attribute_ids: '',
  p_attribute_match_mode: 'AND'
};
export const fetchGetVisitsV2 = async (keycloak, agency, params = {}) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  const query = new URLSearchParams({
    agency
  });
  Object.entries(_objectSpread(_objectSpread({}, defaultGetVisitsV2Params), params)).forEach(([key, value]) => query.set(key, String(value)));
  const url = `${process.env.REACT_APP_AUTH_PROXY_URL}/api/query/rpc/getvisits_v2?${query}`;
  return fetch(url, {
    headers,
    credentials: 'same-origin'
  });
};
export const getVisitByPersonAndVisitIdV2 = async (personNumber, patientVisitId, agency, keycloak, patientNumber) => {
  try {
    const response = await fetchGetVisitsV2(keycloak, agency, {
      p_patientnumber: patientNumber || '',
      p_personnumber: personNumber || '',
      p_patientvisit_id: patientVisitId || '',
      p_latest: false
    });
    return await response.json();
  } catch (e) {
    console.error('An error occured making an api call to get visit information. ', e);
    throw e;
  }
};
export const getVisitByVisitIdV2 = async (patientVisitId, agency, keycloak, patientNumber) => {
  try {
    const response = await fetchGetVisitsV2(keycloak, agency, {
      p_patientnumber: patientNumber || '',
      p_patientvisit_id: patientVisitId || '',
      p_latest: false
    });
    return await response.json();
  } catch (e) {
    console.error('An error occured making an api call to get visit information. ', e);
    throw e;
  }
};
export const getVisitByPersonAndVisitId = async (personNumber, patientVisitId, agency, keycloak, patientNumber) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getvisits?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patientNumber || ''}`;
  authProxyUrl += `&p_patient_id=`;
  authProxyUrl += `&p_personnumber=${personNumber || ''}`;
  authProxyUrl += `&p_person_id=`;
  authProxyUrl += `&p_fromdate=`;
  authProxyUrl += `&p_todate=`;
  authProxyUrl += `&p_visitstatus=`;
  authProxyUrl += `&p_latest=false`;
  authProxyUrl += `&p_patientvisit_id=${patientVisitId || ''}`;
  authProxyUrl += `&p_siteoffice=`;
  authProxyUrl += `&p_mindurationmins=`;
  authProxyUrl += `&p_minchartingmins=`;
  authProxyUrl += `&p_attribute_ids=`;
  let response;

  try {
    response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });
    return await response.json();
  } catch (e) {
    console.error('An error occured making an api call to get visit information. ', e);
    throw e;
  }
};
export const getVisitByVisitId = async (patientVisitId, agency, keycloak, patientNumber) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getvisits?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patientNumber || ''}`;
  authProxyUrl += `&p_patient_id=`;
  authProxyUrl += `&p_personnumber=`;
  authProxyUrl += `&p_person_id=`;
  authProxyUrl += `&p_fromdate=`;
  authProxyUrl += `&p_todate=`;
  authProxyUrl += `&p_visitstatus=`;
  authProxyUrl += `&p_latest=false`;
  authProxyUrl += `&p_patientvisit_id=${patientVisitId || ''}`;
  authProxyUrl += `&p_siteoffice=`;
  authProxyUrl += `&p_mindurationmins=`;
  authProxyUrl += `&p_minchartingmins=`;
  authProxyUrl += `&p_attribute_ids=`;
  let response;

  try {
    response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });
    return await response.json();
  } catch (e) {
    console.error('An error occured making an api call to get visit information. ', e);
    throw e;
  }
};
export const getPatientInProgressVisitForPerson = async (keycloak, patient, personNumber, personId, agency, visitstatus) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getpatientvisits?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${patient === null || patient === void 0 ? void 0 : patient.patientNumber}`;
  authProxyUrl += `&p_patient_id=${patient === null || patient === void 0 ? void 0 : patient.id}`;
  authProxyUrl += `&p_personnumber=${personNumber || ''}`;
  authProxyUrl += `&p_person_id=${personId || ''}`;
  authProxyUrl += `&p_visitstatus=${visitstatus}`;
  authProxyUrl += `&p_rolegroup=null`;
  authProxyUrl += `&p_latest=true`;
  const response = await fetch(authProxyUrl, {
    headers,
    credentials: 'same-origin'
  });

  if (response.status === 200) {
    const priorvisit = await response.json();
    const priorVisitRes = priorvisit && priorvisit.length ? priorvisit[0] : null;
    return priorVisitRes;
  }

  return null;
};
export const getPatientInProgressVisit = async (keycloak, patient, currentUser, agency, visitstatus) => getPatientInProgressVisitForPerson(keycloak, patient, (currentUser === null || currentUser === void 0 ? void 0 : currentUser.personNumber) || '', `${(currentUser === null || currentUser === void 0 ? void 0 : currentUser.userId) || ''}`, agency, visitstatus);
export const getAllInProgPatientVisits = async (agency, keycloak, patient) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getvisits?agency=${agency}`;
  authProxyUrl += `&p_patientnumber=${(patient === null || patient === void 0 ? void 0 : patient.patientNumber) || ''}`;
  authProxyUrl += `&p_patient_id=`;
  authProxyUrl += `&p_personnumber=`;
  authProxyUrl += `&p_person_id=`;
  authProxyUrl += `&p_fromdate=`;
  authProxyUrl += `&p_todate=`;
  authProxyUrl += `&p_visitstatus=In Progress`;
  authProxyUrl += `&p_latest=false`;
  authProxyUrl += `&p_patientvisit_id=`;
  authProxyUrl += `&p_siteoffice=`;
  authProxyUrl += `&p_mindurationmins=`;
  authProxyUrl += `&p_minchartingmins=`;
  authProxyUrl += `&p_attribute_ids=`;
  let response;

  try {
    response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });
    return await response.json();
  } catch (e) {
    console.error('An error occured making an api call to get visit information. ', e);
    throw e;
  }
};
export const getVisitsByIds = async (ids, siteId, agency, keycloak) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Content-Type', 'application/json');
  let authProxyUrl = `${window.env.hosts.pimreaderServiceUrl}`;
  authProxyUrl += `/pimreader/getvisitdetailsforsite?agency=${agency}`; // @note endpoint supports these additional filters

  const payload = {
    // fromdate: fromDate,
    // todate: toDate,
    siteid: siteId,
    visitlist: ids // visitstatus: visitStatus,
    // mindurationmins: minDurationMins,
    // minchartingmins: minChartingMins,

  };
  let response;

  try {
    response = await fetch(authProxyUrl, {
      method: 'POST',
      headers,
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    return await response.json();
  } catch (e) {
    console.error('An error occurred making an api call to get visit information. ', e);
    throw e;
  }
}; // @note moved from out of visit-log
// gets initial list of patient visits

export const formatAttributeIdsParam = attributeIds => attributeIds !== null && attributeIds !== void 0 && attributeIds.length ? attributeIds.join(',') : '';
export const formatAttributeMatchModeParam = matchMode => matchMode === 'OR' ? 'OR' : 'AND';
export const attributeIdsForVisitFetch = (patient, filteringAttributes, summaryAttributeIds) => patient ? undefined : filteringAttributes || summaryAttributeIds;
export const attributeMatchModeForVisitFetch = (patient, summaryAttributeMatchMode) => patient ? undefined : summaryAttributeMatchMode;
export const fetchPimreaderVisitsForPatient = async (keycloak, agency, patient, person, fromDate, toDate, minDurationHH, minDurationMM, chartAfterDD, chartAfterHH, attributeIds, attributeMatchMode) => {
  let minDuration = minDurationHH && Number.parseInt(minDurationHH) * 60 || 0;

  if (minDurationMM) {
    minDuration += Number.parseInt(minDurationMM);
  }

  let chartAfter = chartAfterDD && Number.parseInt(chartAfterDD) * 24 * 60 || 0;

  if (chartAfterHH) {
    chartAfter += Number.parseInt(chartAfterHH) * 60;
  }

  if (!keycloak) return null;
  const response = await fetchGetVisitsV2(keycloak, agency, {
    p_patientnumber: (patient === null || patient === void 0 ? void 0 : patient.patientNumber) || '',
    p_patient_id: (patient === null || patient === void 0 ? void 0 : patient.id) || '',
    p_personnumber: (person === null || person === void 0 ? void 0 : person.personnumber) || '',
    p_person_id: (person === null || person === void 0 ? void 0 : person.person_id) || '',
    p_fromdate: formatPostDateIfDefined(fromDate),
    p_todate: formatPostDateIfDefined(toDate),
    p_latest: false,
    p_patientvisit_id: -1,
    p_siteoffice: person && person.siteoffice || '',
    p_mindurationmins: minDuration,
    p_minchartingmins: chartAfter,
    p_attribute_ids: formatAttributeIdsParam(attributeIds),
    p_attribute_match_mode: formatAttributeMatchModeParam(attributeMatchMode)
  }); // A 504 is a Gateway Timeout Error

  if (response.status === 200) {
    const priorVisits = await response.json();
    return priorVisits.sort((valueA, valueB) => new Date(valueB.effectivedatetime).getTime() - new Date(valueA.effectivedatetime).getTime());
  }

  return null;
};
export const getSiteFaxList = async (agency, keycloak) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getfacilityfaxnumbers?agency=${agency}`;
  let response;

  try {
    response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });
    return await response.json();
  } catch (e) {
    console.error('An error occurred fetching fax list. ', e);
    throw e;
  }
};

/** Thrown when form list cannot be loaded safely (callers should show try-again). */
export class FormListV2Error extends Error {
  constructor() {
    super('Unable to load form list');
    this.name = 'FormListV2Error';
  }

}
/**
 * Shared getformlist_v2 call (Forms list + Election Addendum open).
 * Returns the raw RPC array, or null when there is no token (no logout).
 * Throws FormListV2Error on roles/HTTP/parse failure — do not treat as empty list.
 */

export const getFormListV2 = async ({
  keycloak,
  pim,
  agency,
  currentUser,
  patient,
  levelOfCare
}) => {
  if (!(keycloak !== null && keycloak !== void 0 && keycloak.token)) {
    return null;
  }

  try {
    const headers = await getHeaders(keycloak);
    headers.set('Authorization', `Bearer ${keycloak.token}`);
    const authProxyBase = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
    let program = '-1';
    const pediatric = moment(Date.now()).diff(moment(patient === null || patient === void 0 ? void 0 : patient.dateOfBirth), 'years') < 18;
    const {
      programSiteId
    } = patient || {};

    if (programSiteId != null) {
      const programUrl = `${authProxyBase}/api/query/programsite?agency=${agency}&select=program_id&id=eq.${programSiteId}`;
      const programResponse = await fetch(programUrl, {
        headers,
        credentials: 'same-origin'
      });

      if (programResponse.ok) {
        const programJson = await programResponse.json();

        if (Array.isArray(programJson) && programJson.length) {
          program = programJson[0].program_id;
        }
      }
    }

    let roles;

    try {
      roles = await pim.getPersonRoles(currentUser.userId, agency, `${currentUser.currentHospiceId}`, currentUser.siteId);
    } catch (e) {
      console.error('getFormListV2: getPersonRoles failed', e);
      throw new FormListV2Error();
    }

    if (!Array.isArray(roles)) {
      console.error('getFormListV2: getPersonRoles returned non-array', roles);
      throw new FormListV2Error();
    }

    const rolelist = roles.map(role => role.shortName).join(',');
    headers.set('Accept-Profile', 'pimreader');
    const loc = levelOfCare != null && levelOfCare !== '' ? levelOfCare : (patient === null || patient === void 0 ? void 0 : patient.loc) || '';
    let authProxyUrl = `${authProxyBase}`;
    authProxyUrl += `/api/query/rpc/getformlist_v2?agency=${agency}`;
    authProxyUrl += `&p_personnumber=${currentUser.personNumber}`;
    authProxyUrl += `&p_patientnumber=${patient === null || patient === void 0 ? void 0 : patient.patientNumber}`;
    authProxyUrl += `&p_rolelist=${rolelist}`;
    authProxyUrl += `&p_levelofcare=${loc}`;
    authProxyUrl += `&p_facilitytype=`;
    authProxyUrl += `&p_legacyvisittype=ALL`;
    authProxyUrl += `&p_intermediary=ALL`;
    authProxyUrl += `&p_program_id=${program}`;
    authProxyUrl += `&p_qcode=`;
    authProxyUrl += `&p_ispediatric=${pediatric}`;
    const response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });

    if (response.status !== 200) {
      console.error('getFormListV2: unexpected status', response.status);
      throw new FormListV2Error();
    }

    const forms = await response.json();

    if (!Array.isArray(forms)) {
      console.error('getFormListV2: response is not an array', forms);
      throw new FormListV2Error();
    }

    return forms;
  } catch (e) {
    if (e instanceof FormListV2Error) {
      throw e;
    }

    console.error('getFormListV2 failed', e);
    throw new FormListV2Error();
  }
};
/**
 * Fetch the site email recipient list: facilities with an email address plus
 * physicians with a person email (pimreader OP-33055).
 */

export const getSiteEmailList = async (agency, keycloak) => {
  const headers = await getHeaders(keycloak);
  headers.set('Authorization', `Bearer ${keycloak.token}`);
  headers.set('Accept-Profile', 'pimreader');
  let authProxyUrl = `${process.env.REACT_APP_AUTH_PROXY_URL}`;
  authProxyUrl += `/api/query/rpc/getfacilityandphysicianemailaddresses?agency=${agency}`;
  let response;

  try {
    response = await fetch(authProxyUrl, {
      headers,
      credentials: 'same-origin'
    });
    return await response.json();
  } catch (e) {
    console.error('An error occurred fetching email list. ', e);
    throw e;
  }
};